import React, { useState, useEffect } from 'react';
import io from 'socket.io-client';
import ScrollToBottom from 'react-scroll-to-bottom';
import ReactEmoji from 'react-emoji';
import { PORT_SERVER } from '../../../Config';
import './ChatPage.css';
import styled from 'styled-components';
import moment from 'moment';
import { UserProfile } from '../../utils/ProductCard';

let socket;

const StyledScrollView = styled(ScrollToBottom)`
    height: calc(100vh - 62px - 52px);
`;

const InfoBar = ({ roomTitle }) => (
    <div className='infoBar'>
        <div className='leftInnerContainer'>
            <a href='javascript:history.back()'>
                {'<'}
            </a>
            {roomTitle}
        </div>
        <div className='rightInnerContainer'>
            =
        </div>
    </div>
)

const Input = ({ setMessage, sendMessage, message }) => (
    <form className='form'>
        <input
            className='input'
            type='text'
            placeholder='전송하려는 메세지를 입력하세요.'
            value={message}
            onChange={({ target: { value } }) => setMessage(value)}
            onKeyPress={(event) =>
                event.key === 'Enter' ? sendMessage(event) : null
            }
        />
        <button className='sendButton' onClick={(e) => sendMessage(e)}>
            전송
        </button>
    </form>
)

const Message = ({ message: { message, writer, createdAt, updatedAt }, user }) => {
    let isSentByCurrentUser = false
    let isSystemMessage = false

    if (writer?._id || writer) {
        if ((writer?._id || writer) === user?._id) {
            isSentByCurrentUser = true
        }
        else {
            //SentByOthers
        }
    }
    else {
        isSystemMessage = true
    }

    return isSystemMessage ? (
        <div className='messageContainer'>
            <p className='messageText'>{ReactEmoji.emojify(message)}</p>
        </div>
    ) : isSentByCurrentUser ? (
        <div className='messageContainer justifyEnd'>
            <p className='sentText pr-10'>
                {moment(createdAt).format('A h:mm')}
            </p>
            <div className='messageBox backgroundBlue'>
                <p className='messageText colorWhite'>{ReactEmoji.emojify(message)}</p>
            </div>
        </div>
    ) : (
        <div className='messageContainer justifyStart'>
            <UserProfile user={writer} />
            <div className='messageBox backgroundLight'>
                <p className='messageText colorDark'>{ReactEmoji.emojify(message)}</p>
            </div>
            <p className='sentText pl-10 '>
                {moment(createdAt).format('A h:mm')}
            </p>
        </div>
    )
}

const Messages = ({ messages, user }) => (
    <StyledScrollView className='messages'>
        {messages?.map((msgObj, i) => {
            return (
                <div key={i}>
                    <Message message={msgObj} user={user} />
                </div>
            )
        })}
    </StyledScrollView>
)

const TextContainer = ({ users }) => (
    <div className='textContainer'>
        <div>
            <h1>
                💬실시간 채팅 프로그램{' '}
            </h1>
        </div>
        {users ? (
            <div>
                <h1>현재 채팅중인 사람들 : </h1>
                <div className='activeContainer'>
                    <h2>
                        {users.map(({ name }) => (
                            <div key={name} className='activeItem'>
                                {name}
                                X
                            </div>
                        ))}
                    </h2>
                </div>
            </div>
        ) : null}
    </div>
)


function ChatDetailPage(props) {

    const state = props.location.state;
    const secondMember = state?.secondMember;
    let chatRoom = state?.chatRoom;

    const [RoomTitle, setRoomTitle] = useState('');
    const [users, setUsers] = useState('');
    const [me, setMe] = useState(props.user?.userData);
    const [message, setMessage] = useState('');
    const [messages, setMessages] = useState(chatRoom?.messages || []);
    let arrMessages = chatRoom?.messages || []; //setMessages로 통합시 간헐적 messages 배열 초기화되는 버그 방지를 위해 필요

    useEffect(() => {
        const userTmp = props.user?.userData;
        setMe(userTmp);

        if (userTmp) {
            //console.log(name + '님이 ' + chatRoom?.title + '방에 입장 요청.');
            socket.emit('join', { room: chatRoom, me: userTmp, secondMember }, ({ error, roomJoined }) => {
                if (error) {
                    console.log(error);
                    alert(error);
                    return;
                }

                if (roomJoined) {
                    chatRoom = roomJoined;
                    arrMessages = chatRoom.messages;
                    setMessages(arrMessages);
                }

                setRoomTitle(chatRoom?.title);
            });
        }

    }, [props]);

    useEffect(() => {
        //로딩 될때만 실행
        const rootURL = (process.env.NODE_ENV === "development") ? `http://localhost:${PORT_SERVER}` : '';
        socket = io(rootURL);

        socket.on('message', (message) => {
            arrMessages = [...arrMessages || [], message];
            setMessages(arrMessages);
        });

        socket.on('roomData', ({ users }) => {
            console.log('users:', users);
            setUsers(users);
        });

        return () => {
            //detroyer
            socket.emit('leaveRoom', { room: chatRoom }, (err) => {
                if (err) console.log(err);
            })
        }

    }, []);

    const sendMessage = (event) => {
        event.preventDefault();
        if (message) {
            socket.emit('sendMessage', { message, user: me }, (err) => {
                if (err) {
                    alert(err);
                    console.log(err);
                    props.history.goBack();
                }
                setMessage('');
            });
        }
    };

    return (
        <div className='outerContainer'>
            <div className='container'>
                {/* <InfoBar roomTitle={RoomTitle} /> */}
                <Messages messages={messages} user={me} />
                <Input
                    message={message}
                    setMessage={setMessage}
                    sendMessage={sendMessage}
                />
            </div>
            <TextContainer users={users} />
        </div>
    );
}

export default ChatDetailPage;